'use client';

/**
 * AnalyticsProvider
 *
 * Analytics 초기화 및 Super Properties 관리:
 * 1. 트래커 초기화 (앱 시작 시 1회)
 * 2. Super Properties 관리 (page_path, previous_page_path 등)
 *
 * @note 이벤트 트래킹 로직은 GlobalAnalyticsTracker에서 처리합니다.
 */
import { usePathname } from 'next/navigation';
import { useEffect, useRef } from 'react';

import { updatePageSuperProperties } from './providers/mixpanel';
import { getAnalyticsTracker } from './tracker';

interface AnalyticsProviderProps {
  children: React.ReactNode;
}

export function AnalyticsProvider({ children }: AnalyticsProviderProps) {
  const pathname = usePathname();
  const previousPathRef = useRef<string | undefined>(undefined);

  // 🎯 트래커 초기화 (앱 시작 시 1회)
  useEffect(() => {
    getAnalyticsTracker();
  }, []);

  // 🎯 라우트 변경 시 동적 Super Properties 업데이트
  useEffect(() => {
    if (!pathname) {
      return;
    }

    updatePageSuperProperties(pathname, previousPathRef.current);
    previousPathRef.current = pathname;
  }, [pathname]);

  return <>{children}</>;
}
